import React from 'react';
import { Empty } from 'antd';
import {
  MessageOutlined, UserSwitchOutlined, CheckOutlined, FileImageOutlined,
  FilePdfOutlined, DownloadOutlined, CloseCircleFilled,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { formatBytes, isImageAttachment } from './workTaskHelpers';
import { linkifyText } from '../../utils/linkify';

// Bir işin tüm hareketlerini (ilk atama, devir, not, dosya, tamamlama) tek bir
// kronolojik akışta gösterir. Detay sayfasının ana içeriği - kullanıcının
// bildirime tıkladığında görmek istediği "kim, ne zaman, ne yazdı" tam olarak
// burası.
//
// Liste sayfasında satır içinde daraltılmış halde gösteriliyordu; okunması zor
// olduğu ve bildirimden buraya doğrudan gelinemediği için kendi sayfasına
// taşındı.
const KIND_ICON = {
  assigned:   <UserSwitchOutlined style={{ color: '#1677ff' }} />,
  handoff:    <UserSwitchOutlined style={{ color: '#722ed1' }} />,
  note:       <MessageOutlined style={{ color: '#1677ff' }} />,
  completed:  <CheckOutlined style={{ color: '#52c41a' }} />,
};

const WorkTaskTimeline = ({ timeline, currentUser, isManager, onPreview, onDeleteAttachment }) => {
  if (!timeline || timeline.length === 0) {
    return <Empty description="Bu iş için henüz bir hareket yok." image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <div>
      {timeline.map((ev, idx) => {
        const att = ev.attachment;
        const canDeleteAttachment = att && (att.uploader?.id === currentUser?.id || isManager);

        return (
          <div
            key={ev.id}
            style={{
              display: 'flex',
              gap: 10,
              padding: '10px 0',
              borderTop: idx > 0 ? '1px solid #f0f0f0' : 'none',
            }}
          >
            <div style={{ paddingTop: 2, fontSize: 16 }}>
              {ev.kind === 'attachment'
                ? (isImageAttachment(att?.original_name)
                    ? <FileImageOutlined style={{ color: '#722ed1' }} />
                    : <FilePdfOutlined style={{ color: '#ff4d4f' }} />)
                : KIND_ICON[ev.kind]}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="flex items-baseline gap-2 flex-wrap">
                <span style={{ fontWeight: 600 }}>
                  {ev.kind === 'assigned'  && 'İlk atama'}
                  {ev.kind === 'handoff'   && `${ev.actor} devretti`}
                  {ev.kind === 'note'      && ev.actor}
                  {ev.kind === 'completed' && `${ev.actor} tamamladı`}
                  {ev.kind === 'attachment' && `${ev.actor} dosya ekledi`}
                </span>
                {(ev.kind === 'assigned' || ev.kind === 'handoff') && ev.target && (
                  <span className="text-gray-500">→ {ev.target}</span>
                )}
                <span className="text-gray-400 text-xs" style={{ marginLeft: 'auto' }}>
                  {dayjs(ev.date).format('DD.MM.YYYY HH:mm')}
                </span>
              </div>

              {ev.kind === 'note' && (
                <div style={{ whiteSpace: 'pre-wrap', marginTop: 2 }}>{linkifyText(ev.note)}</div>
              )}

              {(ev.kind === 'handoff' || ev.kind === 'completed') && ev.note && (
                <div className="text-gray-500" style={{ whiteSpace: 'pre-wrap', marginTop: 2 }}>
                  Not: {linkifyText(ev.note)}
                </div>
              )}

              {ev.kind === 'attachment' && att && (
                <div className="flex items-center gap-2 flex-wrap" style={{ marginTop: 2 }}>
                  <span
                    className="cursor-pointer text-blue-600 hover:underline"
                    onClick={() => onPreview?.({
                      url: att.stream_url,
                      name: att.original_name,
                      isImage: isImageAttachment(att.original_name),
                    })}
                  >
                    {att.original_name || `dosya-${att.id}`}
                  </span>
                  <span className="text-gray-400 text-xs">{formatBytes(att.file_size)}</span>
                  <a href={att.download_url} title="İndir" target="_blank" rel="noopener noreferrer">
                    <DownloadOutlined className="text-gray-500" />
                  </a>
                  {canDeleteAttachment && (
                    <CloseCircleFilled
                      className="text-gray-400 hover:text-red-500 cursor-pointer"
                      onClick={() => onDeleteAttachment?.(att)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WorkTaskTimeline;
